<template>
    <div class="container">
        <div class="row">
            <div class="col-md-8 col-md-offset-2">
                <div class="panel panel-default">
                    <div class="panel-heading">Chats</div>

                    <div class="panel-body">
                        <chat-messages  :messages="messages"></chat-messages>
                    </div>
                    <div class="panel-footer">
                        <chat-form
                            v-on:messagesent="addMessage"
                            :user="$page.props.user"
                        ></chat-form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ChatMessages from "@/Components/ChatMessage/ChatMessages";
import ChatForm from "@/Components/ChatMessage/ChatForm";
export default {
    components: {
        ChatForm,
        ChatMessages
    },
    data() {
        return {
            messages: []
        }
    },
    created() {
        this.fetchMessages();
        Echo.join('chat')
            .listen('MessageSent', (e) => {
                console.log('message received...')
                this.messages.push({
                    message: e.message.message,
                    user: e.user
                });
            })
            .here((users) => {
                //
                console.log(users);
            })
            .joining((user) => {
                console.log('joning');
                console.log(user.name);
            })
            .leaving((user) => {
                console.log('leaving');
                axios.post('/leaving').then(response => {
                    // this.messages = response.data;
                });
                console.log(user.name);
            })
            .error((error) => {
                console.log('erro');
                console.error(error);
            });
    },

    methods: {
        fetchMessages() {
            axios.get('/messages').then(response => {
                this.messages = response.data;
            });
        },

        addMessage(message) {
            this.messages.push(message);

            axios.post('/messages', message).then(response => {
            });
        }
    }
}
</script>
<style>
.chat {
    list-style: none;
    margin: 0;
    padding: 0;
}

.chat li {
    margin-bottom: 10px;
    padding-bottom: 5px;
    border-bottom: 1px dotted #B3A9A9;
}

.chat li .chat-body p {
    margin: 0;
    color: #777777;
}

.panel-body {
    overflow-y: scroll;
    height: 350px;
}

::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    background-color: #F5F5F5;
}

::-webkit-scrollbar {
    width: 12px;
    background-color: #F5F5F5;
}

::-webkit-scrollbar-thumb {
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
    background-color: #555;
}
</style>
